export default __webpack_public_path__ + "static/media/it-45.6b59bb0d.svg";